import axios from "axios"
import { post, del, get, put, patch } from "./api_helper"
import * as url from "./url_helper"

// Companies API (Admin)
export const getCompanies = () => get(url.GET_COMPANIES);
export const getCompanyDetail = id => get(`${url.GET_COMPANY_DETAIL}/${id}`);
export const addNewCompany = company => post(url.GET_COMPANIES, company);
export const updateCompany = company => put(`${url.UPDATE_COMPANY}/${company.id}`, company);
export const deleteCompany = id => del(`${url.DELETE_COMPANY}/${id}`);
export const toggleCompanyStatus = id => patch(`${url.TOGGLE_COMPANY_STATUS}/${id}/toggle-status`);
export const assignCompanyPlan = (id, data) => post(`${url.GET_COMPANIES}/${id}/assign-plan`, data);

// Plans API (Admin)
export const getPlans = () => get(url.GET_PLANS);
export const addNewPlan = plan => post(url.ADD_PLAN, plan);
export const updatePlan = plan => put(`${url.UPDATE_PLAN}/${plan.id}`, plan);
export const deletePlan = id => del(`${url.DELETE_PLAN}/${id}`);

// Customers API (Company)
export const getCustomers = params => get(url.GET_CUSTOMERS, { params })
export const addNewCustomer = customer => post(url.ADD_CUSTOMER, customer)
export const updateCustomer = customer =>
  put(`${url.UPDATE_CUSTOMER}/${customer.id}`, customer)
export const deleteCustomer = id => del(`${url.DELETE_CUSTOMER}/${id}`)
export const getCustomerDetail = id => get(`${url.GET_CUSTOMERS}/${id}`)
export const exportCustomers = () => get(url.EXPORT_CUSTOMERS, { responseType: 'blob' })

// Company Users Management
export const getCompanyUsers = () => get(url.GET_COMPANY_USERS)
export const addNewCompanyUser = user => post(url.GET_COMPANY_USERS, user)
export const updateCompanyUser = user => put(`${url.GET_COMPANY_USERS}/${user.id}`, user)
export const deleteCompanyUser = id => del(`${url.GET_COMPANY_USERS}/${id}`)
export const getCompanyRoles = () => get(url.GET_COMPANY_ROLES)

// Interactions
export const getInteractions = customerId => get(url.INTERACTIONS, { params: { customer_id: customerId } })
export const addNewInteraction = data => post(url.INTERACTIONS, data)

// Documents
export const getDocuments = (id, type) => get(url.DOCUMENTS, { params: { documentable_id: id, documentable_type: type } })
export const addNewDocument = data => {
  const formData = new FormData()
  Object.keys(data).forEach(key => formData.append(key, data[key]))
  return post(url.DOCUMENTS, formData, { headers: { "Content-Type": "multipart/form-data" } })
}
export const deleteDocument = id => del(`${url.DOCUMENTS}/${id}`)

// Custom Fields
export const getCustomFields = modelType => get(url.CUSTOM_FIELDS, { params: { model_type: modelType } })

// Customer Categories
export const getCustomerCategories = () => get(url.CUSTOMER_CATEGORIES)

// Dashboard (Company)
export const getCompanyDashboardStats = () => get(url.GET_COMPANY_DASHBOARD_STATS)

// Subscription (Company)
export const getCurrentSubscription = () => get("/subscription/current")

// Admin - Subscription Management
export const getPendingSubscriptions = () => get(url.ADMIN_SUBSCRIPTIONS_PENDING)
export const getAllSubscriptions = (params) => get(url.ADMIN_SUBSCRIPTIONS_ALL, { params })
export const getSubscriptionStats = () => get(url.ADMIN_SUBSCRIPTIONS_STATS)
export const validateSubscriptionPayment = (id, data) => post(`${url.ADMIN_SUBSCRIPTION_VALIDATE}/${id}/validate-payment`, data)
export const createSubscriptionForCompany = (data) => post(`${url.ADMIN_SUBSCRIPTION_VALIDATE}/create`, data)

// Suppliers
export const getSuppliers = params => get(url.SUPPLIERS, { params })
export const getAllSuppliers = () => get(`${url.SUPPLIERS}/all`)
export const addNewSupplier = supplier => post(url.SUPPLIERS, supplier)
export const updateSupplier = supplier => put(`${url.SUPPLIERS}/${supplier.id}`, supplier)
export const deleteSupplier = id => del(`${url.SUPPLIERS}/${id}`)

// Supplier Invoices
export const getSupplierInvoices = params => get(url.SUPPLIER_INVOICES, { params })
export const addNewSupplierInvoice = invoice => post(url.SUPPLIER_INVOICES, invoice, { headers: { "Content-Type": "multipart/form-data" } })
export const updateSupplierInvoice = invoice => post(`${url.SUPPLIER_INVOICES}/${invoice.id}`, invoice, { headers: { "Content-Type": "multipart/form-data" } })
export const deleteSupplierInvoice = id => del(`${url.SUPPLIER_INVOICES}/${id}`)

// Billing - Quotes
export const getQuotes = params => get(url.QUOTES, { params })
export const getQuoteDetail = id => get(`${url.QUOTES}/${id}`)
export const addNewQuote = quote => post(url.QUOTES, quote)
export const updateQuote = quote => put(`${url.QUOTES}/${quote.id}`, quote)
export const deleteQuote = id => del(`${url.QUOTES}/${id}`)
export const convertQuoteToInvoice = id => post(`${url.QUOTES}/${id}/convert`)
export const getQuotePdf = id => get(`${url.QUOTES}/${id}/pdf`, { responseType: 'blob' })

// Billing - Invoices
export const getInvoices = params => get(url.INVOICES, { params })
export const getInvoiceDetail = id => get(`${url.INVOICES}/${id}`)
export const addNewInvoice = invoice => post(url.INVOICES, invoice)
export const updateInvoice = invoice => put(`${url.INVOICES}/${invoice.id}`, invoice)
export const deleteInvoice = id => del(`${url.INVOICES}/${id}`)
export const getInvoicePdf = id => get(`${url.INVOICES}/${id}/pdf`, { responseType: 'blob' })
export const addCreditNote = (id, data) => post(`${url.INVOICES}/${id}/credit-note`, data)

// Billing - Payments
export const getPayments = params => get(url.PAYMENTS, { params })
export const addNewPayment = payment => post(url.PAYMENTS, payment)
export const deletePayment = id => del(`${url.PAYMENTS}/${id}`)

// Products & Services
export const getProducts = params => get(url.PRODUCTS, { params })
export const getProductDetail = id => get(`${url.PRODUCTS}/${id}`)
export const addNewProduct = product => post(url.PRODUCTS, product)
export const updateProduct = product => put(`${url.PRODUCTS}/${product.id}`, product)
export const deleteProduct = id => del(`${url.PRODUCTS}/${id}`)

// System Users API (Super Admin)
export const getSystemUsers = () => get(url.GET_SYSTEM_USERS);
export const addNewSystemUser = user => post(url.GET_SYSTEM_USERS, user);
export const updateSystemUser = user => put(`${url.GET_SYSTEM_USERS}/${user.id}`, user);
export const deleteSystemUser = id => del(`${url.GET_SYSTEM_USERS}/${id}`);

// Roles API (Super Admin)
export const getRoles = () => get(url.GET_ROLES);
export const getRoleDetail = id => get(`${url.GET_ROLES}/${id}`);
export const addNewRole = role => post(url.GET_ROLES, role);
export const updateRole = role => put(`${url.GET_ROLES}/${role.id}`, role);
export const deleteRole = id => del(`${url.GET_ROLES}/${id}`);
export const getPermissionsGrouped = () => get(url.GET_PERMISSIONS_GROUPED);
export const getPermissionsList = () => get(url.PERMISSIONS);
export const addNewPermission = permission => post(url.PERMISSIONS, permission);
export const updatePermission = permission => put(`${url.PERMISSIONS}/${permission.id}`, permission);
export const deletePermission = id => del(`${url.PERMISSIONS}/${id}`);

// Dashboard API (Super Admin)
export const getAdminDashboardStats = () => get(url.GET_ADMIN_DASHBOARD_STATS);
export const getSalesStats = () => get(url.GET_SALES_STATS);

// Invoices API (Super Admin)
export const getAdminInvoices = () => get(url.GET_ADMIN_INVOICES);
export const updateInvoiceStatus = (id, status) => patch(`${url.GET_ADMIN_INVOICES}/${id}/status`, { status });
export const addAdminCreditNote = (id, data) => post(`${url.GET_ADMIN_INVOICES}/${id}/credit-note`, data)

// Settings API (Super Admin)
export const getSystemSettings = () => get(url.GET_SYSTEM_SETTINGS);
export const updateSystemSettings = data => post(url.UPDATE_SYSTEM_SETTINGS_BULK, data);

// Tickets
export const getTickets = params => get(url.TICKETS, { params });
export const getTicketDetail = id => get(`${url.TICKETS}/${id}`);
export const addNewTicket = ticket => post(url.TICKETS, ticket);
export const replySupportTicket = (id, data) => post(`${url.TICKETS}/${id}/reply`, data);

// Admin Tickets
export const getAdminTickets = params => get(url.GET_ADMIN_TICKETS, { params });
export const getAdminTicketDetail = id => get(`${url.GET_ADMIN_TICKETS}/${id}`);
export const updateTicketStatus = (id, data) => put(`${url.GET_ADMIN_TICKETS}/${id}`, data);
export const replyTicket = (id, data) => post(`${url.TICKETS_REPLY}/${id}/reply`, data);

// Admin Company Users Management (Super Admin - Manage users of any company)
export const getAdminCompanyUsers = (companyId) => get(`admin/companies/${companyId}/users`);
export const addAdminCompanyUser = (companyId, data) => post(`admin/companies/${companyId}/users`, data);
export const updateAdminCompanyUser = (companyId, userId, data) => put(`admin/companies/${companyId}/users/${userId}`, data);
export const deleteAdminCompanyUser = (companyId, userId) => del(`admin/companies/${companyId}/users/${userId}`);

// WhatsApp API (Company-specific instance)
export const getWhatsAppStatus = () => get('whatsapp/status');
export const startWhatsApp = () => post('whatsapp/start');
export const stopWhatsApp = () => post('whatsapp/stop');
export const restartWhatsApp = () => post('whatsapp/restart');
export const sendWhatsAppDocument = (data) => post('whatsapp/send-document', data);

// Notifications
export const getNotifications = (params) => get(url.GET_NOTIFICATIONS, { params });
export const markNotificationRead = (id) => post(`${url.GET_NOTIFICATIONS}/${id}/mark-read`);
export const markAllNotificationsRead = () => post(`${url.GET_NOTIFICATIONS}/mark-read`);

// Gets the logged in user data from local session
const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

//is user is logged in
const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// Register Method
const postFakeRegister = data => {
  return axios
    .post(url.POST_FAKE_REGISTER, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      let message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

// Login Method
const postFakeLogin = data => post(url.POST_FAKE_LOGIN, data);

// postForgetPwd
const postFakeForgetPwd = data => post(url.POST_FAKE_PASSWORD_FORGET, data);

// Edit profile
const postJwtProfile = data => post(url.POST_EDIT_JWT_PROFILE, data);

const postFakeProfile = data => post(url.POST_EDIT_PROFILE, data);

// Register Method
const postJwtRegister = (url, data) => post(url, data);

// Login Method
const postJwtLogin = data => post(url.POST_FAKE_JWT_LOGIN, data);

// postForgetPwd
const postJwtForgetPwd = data => post(url.POST_FAKE_JWT_PASSWORD_FORGET, data);

// postSocialLogin
export const postSocialLogin = data => post(url.SOCIAL_LOGIN, data);

// get Events
export const getEvents = () => get(url.GET_EVENTS)

// add Events
export const addNewEvent = event => post(url.ADD_NEW_EVENT, event)

// update Event
export const updateEvent = event => put(url.UPDATE_EVENT, event)

// delete Event
export const deleteEvent = event =>
  del(url.DELETE_EVENT, { headers: { event } })

// get Categories
export const getCategories = () => get(url.GET_CATEGORIES)

// get chats
export const getChats = () => get(url.GET_CHATS);

// get groups
export const getGroups = () => get(url.GET_GROUPS);

// get Contacts
export const getContacts = () => get(url.GET_CONTACTS);

// get messages
export const getMessages = (userId) =>
  get(url.GET_MESSAGES, { params: { user_id: userId } });

export const addMessage = message => post(url.ADD_MESSAGE, message);

export const markRead = senderId => post(url.MARK_READ, { sender_id: senderId });

// delete message
export const deleteMessage = id => del(`${url.DELETE_MESSAGE}/${id}`);

// get tasks
export const getTasks = () => get(url.GET_TASKS);

// add CardData Kanban
export const addCardData = cardData => post(url.ADD_CARD_DATA, cardData);

// update jobs
export const updateCardData = card => put(url.UPDATE_CARD_DATA, card);

// delete Kanban
export const deleteKanban = kanban => del(url.DELETE_KANBAN, { headers: { kanban } });

// export const getUserProfile = () => get(url.GET_USER_PROFILE)

export {
  getLoggedInUser,
  isUserAuthenticated,
  postFakeRegister,
  postFakeLogin,
  postFakeProfile,
  postFakeForgetPwd,
  postJwtRegister,
  postJwtLogin,
  postJwtForgetPwd,
  postJwtProfile,
}
